/* eslint-disable jsx-a11y/iframe-has-title */
import './home.css';
import React, { useState } from 'react';
import EscapeFomo from "../../components/EscapeFomo/EscapeFomo";
import bgnext from '../../assets/images/afc.png';
import igsq from '../../assets/images/igsq.png';
import PhotoGallery from '../../components/PhotoGallery/PhotoGallery';
import WhatNext from "../../components/WhatNext/WhatNext";

import upright from '../../assets/icons/upright.svg';
import { Link } from 'react-router-dom';
import bg from '../../assets/images/friendzonelome-27.jpg';

const Home = () => {

    return (

        <div className="flex justify-center items-center w-full">
            <div className='flex flex-col gap-[80px] bg-offwhite md:max-w-[600px] lg:max-w-[950px] xl:max-w-[1400px] w-full overflow-x-hidden'>

                {/* <div className="flex lg:gap-[25px] gap-2.5 lg:h-[500px] h-[200px] md:h-[300px] w-full font-chido">

                    <Link to={"/event"} className="flex group w-4/6 lg:border-[6px] border-[4px] border-offblack lg:rounded-[20px] rounded-[5px] h-full bg-cover bg-center" style={{ backgroundImage: `url(${bgnext})` }}>
                        <div className="flex flex-col items-start justify-end h-full w-full lg:p-[40px] p-2.5 bglinear50 group-hover:bg-offblack group-hover:bg-opacity-60 transition-all duration-300 ease-in-out">
                            <p className=" text-white lg:text-[35px] text-[10px] flex gap-5">NEXT RENDEZ-VOUS <img className='lg:-mt-2.5 -mt-1 w-2 lg:w-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out' src={upright} alt="" /></p>
                            <p className=" text-white lg:text-[65px] text-[16px] group-hover:mb-5 transition-all duration-300 ease-in-out">16 AUGUST 2025</p>
                        </div>
                    </Link>

                    <div className="flex flex-col lg:gap-[25px] gap-2.5 w-2/6 h-full">

                        <Link
                        to={"/ticket"}
                            className="group flex items-center justify-center h-1/3 lg:border-[6px] border-[4px] border-offblack bg-lifeorange text-white lg:p-[20px] lg:text-[36px] lg:rounded-[20px] rounded-[5px]">
                            <p className="flex flex-col lg:text-[36px] text-[12px]">
                                GRAB YOUR <br />
                                <span className='flex items-center justify-center lg:gap-2.5 gap-1'>
                                    <p>TICKET</p>
                                    
                                    <img className='lg:-mt-2.5 -mt-1 w-2 lg:w-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out' src={upright} alt="" />
                                </span>
                            </p>
                        </Link>

                        <a href="https://www.instagram.com/lafriendzonelome" target="_blank" rel="noreferrer" className="group flex h-2/3 lg:border-[6px] border-[4px] border-offblack text-white lg:rounded-[20px] rounded-[5px] w-full bg-cover bg-center" style={{ backgroundImage: `url(${igsq})` }}>
                            <div className="flex flex-col items-start justify-end text-[36px] h-full w-full lg:pl-[25px] lg:pb-[50px] pl-2.5 pb-2.5 bglinear50 group-hover:bg-offblack group-hover:bg-opacity-60 transition-opacity duration-300 ease-in-out">
                                <p className="flex flex-col xl:text-[36px] lg:text-[34px] text-[12px]">
                                    STAY TUNED ON <br />
                                    <span className='flex items-center justify-center lg:gap-2.5 gap-1'>
                                        <p>INSTAGRAM</p>
                                        
                                        <img className='lg:-mt-2.5 -mt-1 w-2 lg:w-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out' src={upright} alt="" />
                                    </span>
                                </p>
                            </div>
                        </a>


                    </div>

                </div> */}

                <div className="flex lg:gap-[25px] gap-2.5 lg:h-[500px] h-[200px] md:h-[300px] w-full font-chido">

                    <Link to={"/about-us"} className="flex group w-4/6 lg:border-[6px] border-[4px] border-offblack lg:rounded-[20px] rounded-[5px] h-full bg-cover bg-center" style={{ backgroundImage: `url(${bg})` }}>
                        <div className="flex flex-col items-start justify-end h-full w-full lg:p-[40px] p-2.5 bglinear50 group-hover:bg-offblack group-hover:bg-opacity-60 transition-all duration-300 ease-in-out">
                            <p className=" text-white lg:text-[35px] text-[10px] flex gap-5">WE ARE<img className='lg:-mt-2.5 -mt-1 w-2 lg:w-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out' src={upright} alt="" /></p>
                            <p className=" text-white lg:text-[65px] text-[16px] group-hover:mb-5 transition-all duration-300 ease-in-out">LAFRIENDZONE</p>
                        </div>
                    </Link>

                    <div className="flex flex-col lg:gap-[25px] gap-2.5 w-2/6 h-full">

                        <a href="https://www.instagram.com/lafriendzonelome" target="_blank" rel="noreferrer" className="group flex h-full lg:border-[6px] border-[4px] border-offblack text-white lg:rounded-[20px] rounded-[5px] w-full bg-cover bg-center" style={{ backgroundImage: `url(${igsq})` }}>
                            <div className="flex flex-col items-start justify-end text-[36px] h-full w-full lg:pl-[25px] lg:pb-[50px] pl-2.5 pb-2.5 bglinear50 group-hover:bg-offblack group-hover:bg-opacity-60 transition-opacity duration-300 ease-in-out">
                                <p className="flex flex-col xl:text-[36px] lg:text-[34px] text-[12px]">
                                    STAY TUNED ON <br />
                                    <span className='flex items-center justify-center lg:gap-2.5 gap-1'>
                                        <p>INSTAGRAM</p>

                                        <img className='lg:-mt-2.5 -mt-1 w-2 lg:w-auto opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-in-out' src={upright} alt="" />
                                    </span>
                                </p>
                            </div>
                        </a>


                    </div>

                </div>


                <EscapeFomo />

                <PhotoGallery />

                <div className="flex flex-col justify-center items-center lg:gap-[50px]  gap-[12px] ">
                    <h2 className="lg:text-[65px] text-[16px] font-chido">THE COMMUNITY PLAYLIST</h2>

                    <div className="flex lg:w-[700px] w-full">
                        <iframe className='lg:rounded-[20px] rounded-[5px]' src="https://open.spotify.com/embed/playlist/6kbqbxU8YGkejA5qfdO3B7?utm_source=generator&theme=0" width="100%" height="352" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" />
                    </div>
                </div>

                <WhatNext />

            </div>
        </div>
    )
}

export default Home